import React from "react"
import Fade from "react-reveal/Fade"
import data from "../yourdata"

const About = () => {
  return (
    <div className="secion" id="about">
      <div className="container">
        <div className="about-section">
          <div className="content">
            <Fade bottom cascade>
              <h1>About Me</h1>
            </Fade>
            <p>
              {data.aboutParaOne}
              <br></br>
              <br></br>
              {data.aboutParaTwo}
              <br></br>
              <br></br>
              {data.aboutParaThree}
            </p>
          </div>
          <Fade>
          <div className="image-wrapper">
            <img src={data.aboutImage} style={{maxWidth: "50%", maxHeight: "100%"}} alt="about"></img>
          </div>
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default About
